import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Tag_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_TAG_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Tag Id', columnResourceName: 'colWBTagId', alignment: HorizAlignment.Center}, domainOptions: {}},
    TAG_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tag Id', columnResourceName: 'colTagId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    TAG_NAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tag Name', columnResourceName: 'colTagName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    TAG_KEYWORDS:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tag Keywords', columnResourceName: 'colTagKeywords', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    TAG_TYPE:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tag Type', columnResourceName: 'colTagType', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    WB_TAG_SOURCE_ID: {type:SearchProviderFieldType.number, renderOptions: {columnName: 'WB Tag Source Id', columnResourceName: 'colWBTagSourceId', alignment: HorizAlignment.Left}, domainOptions: {}},
    TEXT:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Text', columnResourceName: 'colText', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 1333}}
}

var TagSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_TAG_ID',
        id_ui: 'TAG_ID',
        name:  'TAG_NAME'},

    searchProviderFields: vUI_Tag_Search_Fields,

   search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Tag_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var TagSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "TagSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'TAG_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'TAG_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'TAG_ID','TAG_NAME','TAG_KEYWORDS','TAG_TYPE'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: TagSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var TagSearch: ISearch = {
    searchName: "Find Tag",
    renderOptions: { ui5ResourceId: "TagSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [TagSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("TagBO", "Tag", TagSearch, "Tag Search")

export {TagSearch}